/**
 * plug into the  dom and  append CTT settings
 * Save on change via ajax
 * We can't save rule by rule withough pluggin into the checkout
 * Currently only the instance id is saved
 */
export default class CTTWeightBasedShipping {
  constructor() {
    this.init();
  }

  init() {
    //not a shipping method page
    if (typeof CTT_carrier == "undefined") {
      return;
    }

    const regexInstance = /instance_id=([0-9]*)/.exec(window.location.search);

    if (!regexInstance) {
      return;
    }

    this.instance_id = regexInstance[1];
    this.attachCTTOptions();
  }

  /**
   * Save our options for this instance
   */
  saveOptions(elem) {
    var data = {
      data: this.eForm.serializeArray(),
      instance_id: this.instance_id,
      action: "CTT_wbs_settings",
    };

    jQuery.post(ajaxurl, data, function (resp) {
      console.log("response ", resp);
    });

    jQuery(".CTT-optionvalues").hide();
    var extraOption = jQuery(".CTT-extraoptions").val();
    jQuery("#CTT-extraoptions" + extraOption).show();
  }

  /**
   * Attach the CTT options under the title
   */
  attachCTTOptions() {
    var eCTTOptions = jQuery(
      "<form id='CTToptions' class=\"wbs-CTToptions\"></form>",
    );
    var oHtml = "";

    //no options , nothing to do
    if (typeof CTT_carrier.OptionList == "undefined") {
      return;
    }

    //CTT_extraoptions
    //CTT_checkboxes
    //Add a Save button
    let htmlServiceLevels = "";
    let htmlExtraOptions = "";
    let htmlCheckboxes = "";
    let htmlExtravalues = "";
    for (var x = 0; x < CTT_carrier.OptionList.length; ++x) {
      const option = CTT_carrier.OptionList[x];

      if (option.Type == 1) {
        if (typeof option.OptionValues != "undefined") {
          for (var i = 0; i < option.OptionValues.length; ++i) {
            let optionChild = option.OptionValues[i];
            let selected =
              CTT_options["service_level"] == optionChild.Id
                ? "selected"
                : "";
            htmlServiceLevels +=
              "<option value='" +
              optionChild.Id +
              "' " +
              selected +
              ">" +
              optionChild.Name +
              "</option>";
          }
        }
      } else if (CTT_extraoptions.includes(option.Id + "")) {
        let selected =
          CTT_options["extraoptions"] == option.Id ? "selected" : "";
        htmlExtraOptions +=
          "<option value='" +
          option.Id +
          "' " +
          selected +
          ">" +
          option.Name +
          "</option>";
        if (option.OptionFields && option.OptionFields.length > 0) {
          for (var j = 0; j < option.OptionFields.length; ++j) {
            if (option.OptionFields[j].OptionValues) {
              var optionField = option.OptionFields[j];
              htmlExtravalues +=
                '<select class="CTT-optionvalues" id="CTT-extraoptions' +
                option.Id +
                '" name="extraoptions' +
                option.Id +
                '" onchange=\"CTT.platform.wbs.saveOptions(jQuery(this))\">';
              for (var i = 0; i < optionField.OptionValues.length; ++i) {
                let optionChild = optionField.OptionValues[i];
                let selected =
                  CTT_options["extraoptions" + option.Id] ==
                  optionChild.Id
                    ? "selected"
                    : "";
                htmlExtravalues +=
                  "<option value='" +
                  optionChild.Id +
                  "' " +
                  selected +
                  ">" +
                  optionChild.Name +
                  "</option>";
              }
              htmlExtravalues += "</select>";
            }
          }
        }
      } else {
        const keys = Object.keys(CTT_checkboxes);
        for (var i = 0; i < keys.length; ++i) {
          if (option.Id == keys[i]) {
            let optionName = CTT_checkboxes[option.Id];
            let checked =
              CTT_options[optionName] == option.Id ? "checked" : "";
            htmlCheckboxes +=
              '<span class="wbs-CTT-option"><input ' +
              checked +
              ' class="wbs-rse-checkbox"  onchange="CTT.platform.wbs.saveOptions(jQuery(this))" type="checkbox" name="' +
              optionName +
              '" value="' +
              option.Id +
              '"/>' +
              CTT_checkboxes[option.Id] +
              "</span>";
          }
        }
      }
    }

    if (htmlServiceLevels.length > 0) {
      oHtml +=
        '<span class="wbs-CTT-option"><label>' +
        CTT_labels.servicelevel +
        '</label> <select name="service_level"  onchange="CTT.platform.wbs.saveOptions(jQuery(this))"><option>-</option>' +
        htmlServiceLevels +
        "</select></span>";
    }

    if (htmlExtraOptions.length > 0) {
      oHtml +=
        '<span class="wbs-CTT-option"><label>' +
        CTT_labels.extraoptions +
        '</label> <select class=\'CTT-extraoptions\' name="extraoptions"  onchange="CTT.platform.wbs.saveOptions(jQuery(this))"><option>-</option>' +
        htmlExtraOptions +
        "</select> " +
        htmlExtravalues +
        " </span>";
    }

    oHtml += htmlCheckboxes;

    //Pickup Behaviour?
    if (CTT_carrier.HasPickup) {
      let selecthtml =
        '<select class="CTT-extraoptions" name="pickupbehaviour" onchange=\"CTT.platform.wbs.saveOptions(jQuery(this))\">';
      for (var x = 0; x < 3; ++x) {
        let selected =
          CTT_options["pickupbehaviour"] == x ? "selected" : "";
        selecthtml += `<option value="${x}" ${selected}>${CTT_labels["pickup" + x]}</option>`;
      }
      selecthtml += "</select>";

      oHtml += `<span class=\"wbs-CTT-option\"><label>${CTT_labels.pickupbehaviour}</label> ${selecthtml}</span>`;
    }

    if (oHtml.length > 0) {
      eCTTOptions.html("<h3>CTT Settings</h3>" + oHtml);
      eCTTOptions.insertAfter(jQuery("#mainform"));
      this.eForm = jQuery("#CTToptions");
      this.saveOptions(jQuery(".CTT-extraoptions"));
    }
  }
}
